module.exports = __webpack_public_path__ + "media/src/images/icons/birthday-6aa9e7ed2e494c18c7608f047f63d4b7.svg";